import setCurrentPage from "src/Utils/setCurrentPage";
import store from "src/Reducers/store";
import ConversationEffect from "src/Animations/ConversationEffect";

const previousPage = () => store.getState().appReducer.previousPage;

export const DATA_DIGITAL_TWIN_INLCM_1 = {
  title: `<span style="color: #BEE3FF;">Discover your network </span>\n\nUser to upload network device \nconfiguration, historic \nperformance, alarm and other \nrelevant data.`,
  subtitle: "Digital Twin for Network Transformation",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ENG_311"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(previousPage()),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/INLCM/INLCM_dark_bg_2.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "ENG/INLCM/INLCM_digital_twin_01_computer.png",
          effect: "animate-opacity",
          imageStyle: { position: "absolute", bottom: "160px", right: "0px" },
        },
        {
          image: "ENG/INLCM/INLCM_digital_twin_01_screen.png",
          imageStyle: { position: "absolute", bottom: "235px", right: "83px" },
        },
        {
          image: "ENG/INLCM/INLCM_digital_twin_01_finger.png",
          imageStyle: { position: "absolute", bottom: "82px", right: "699px" },
        },
      ]}
      pageNumber={"ENG_310"}
    />
  ),
};
